import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Antrag from "@/pages/Antrag";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import PaymentReturn from "@/pages/PaymentReturn";
import Legal from "@/pages/Legal";
import Termin from "@/pages/Termin";
import CookieBanner from "@/components/CookieBanner";

function Protected({ children, staff }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Lädt…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (staff && !["admin", "gutachter", "support"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/antrag" element={<Protected><Antrag /></Protected>} />
          <Route path="/portal" element={<Protected><Portal /></Protected>} />
          <Route path="/termin" element={<Protected><Termin /></Protected>} />
          <Route path="/admin" element={<Protected staff><Admin /></Protected>} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentReturn cancel />} />
          <Route path="/impressum" element={<Legal type="impressum" />} />
          <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
          <Route path="/agb" element={<Legal type="agb" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
